// zoe-screens.generated.ts — GENERATED, do not hand-edit.
//
// Regenerate: pnpm screens:generate
// Verify (CI): pnpm screens:generate:check
//
// Source: scripts/build-zoe-screens.mjs, derived from apps/web/src/app/App.tsx
// (the real <Route> table) and apps/web/src/lib/markedUpLetterScreens.ts (human
// titles/segments + the workflow-route -> slug map). Every route registered in
// App.tsx appears here unless listed in EXEMPT_ROUTES (pure redirects / the 404
// wildcard) — see apps/web/src/feedback-toolbar/__tests__/zoe-screens.test.ts for
// the drift guard that fails CI if this file falls behind App.tsx.
//
// Route templates keep their `:param` placeholders — apps/web/src/feedback-toolbar/
// zoe-screens.ts (hand-authored app glue, NOT generated) substitutes sample values
// and marks token-gated routes as non-jumpable.

export interface RawZoeScreen {
  id: string;
  title: string;
  section: string;
  /** May contain `:param` placeholders — see zoe-screens.ts for substitution. */
  route: string;
  /** True when this route only renders inside the authenticated Shell/LetterShell. */
  authRequired: boolean;
  /** Route param names, e.g. ["codename"] for "/deal/:codename/report". */
  params: string[];
}

export const ZOE_SCREEN_ROUTES: RawZoeScreen[] = [
  {
    "id": "admin-config",
    "title": "Admin Config",
    "section": "Admin & Settings",
    "route": "/admin/config",
    "authRequired": true,
    "params": []
  },
  {
    "id": "admin-diagnostics",
    "title": "Admin Diagnostics",
    "section": "Admin & Settings",
    "route": "/admin/diagnostics",
    "authRequired": true,
    "params": []
  },
  {
    "id": "admin-operator-waitlist",
    "title": "Admin Operator Waitlist",
    "section": "Admin & Settings",
    "route": "/admin/operator-waitlist",
    "authRequired": true,
    "params": []
  },
  {
    "id": "legal",
    "title": "Legal",
    "section": "Admin & Settings",
    "route": "/legal",
    "authRequired": false,
    "params": []
  },
  {
    "id": "legal-page",
    "title": "Legal",
    "section": "Admin & Settings",
    "route": "/legal/:page",
    "authRequired": false,
    "params": [
      "page"
    ]
  },
  {
    "id": "settings",
    "title": "Settings",
    "section": "Admin & Settings",
    "route": "/settings",
    "authRequired": true,
    "params": []
  },
  {
    "id": "root",
    "title": "Home Route",
    "section": "Auth & Entry",
    "route": "/",
    "authRequired": false,
    "params": []
  },
  {
    "id": "pay-return",
    "title": "Pay Return",
    "section": "Auth & Entry",
    "route": "/pay/return",
    "authRequired": false,
    "params": []
  },
  {
    "id": "signin",
    "title": "Sign In",
    "section": "Auth & Entry",
    "route": "/signin",
    "authRequired": false,
    "params": []
  },
  {
    "id": "sign-up",
    "title": "Sign In",
    "section": "Auth & Entry",
    "route": "/sign-up",
    "authRequired": false,
    "params": []
  },
  {
    "id": "start",
    "title": "Website Price Wall Redirect",
    "section": "Auth & Entry",
    "route": "/start",
    "authRequired": false,
    "params": []
  },
  {
    "id": "pay",
    "title": "Website Price Wall Redirect",
    "section": "Auth & Entry",
    "route": "/pay",
    "authRequired": false,
    "params": []
  },
  {
    "id": "deal-codename-close",
    "title": "Case Close",
    "section": "Deal Workspace",
    "route": "/deal/:codename/close",
    "authRequired": true,
    "params": [
      "codename"
    ]
  },
  {
    "id": "deal-codename",
    "title": "Case Read",
    "section": "Deal Workspace",
    "route": "/deal/:codename",
    "authRequired": true,
    "params": [
      "codename"
    ]
  },
  {
    "id": "deal-codename-history",
    "title": "Case Read History",
    "section": "Deal Workspace",
    "route": "/deal/:codename/history",
    "authRequired": true,
    "params": [
      "codename"
    ]
  },
  {
    "id": "deal-codename-chat",
    "title": "Company Chat",
    "section": "Deal Workspace",
    "route": "/deal/:codename/chat",
    "authRequired": true,
    "params": [
      "codename"
    ]
  },
  {
    "id": "deal-codename-claims",
    "title": "Company Comparison",
    "section": "Deal Workspace",
    "route": "/deal/:codename/claims",
    "authRequired": true,
    "params": [
      "codename"
    ]
  },
  {
    "id": "deal-codename-claim-check",
    "title": "Company Comparison",
    "section": "Deal Workspace",
    "route": "/deal/:codename/claim-check",
    "authRequired": true,
    "params": [
      "codename"
    ]
  },
  {
    "id": "deal-codename-deck",
    "title": "Company Deck",
    "section": "Deal Workspace",
    "route": "/deal/:codename/deck",
    "authRequired": true,
    "params": [
      "codename"
    ]
  },
  {
    "id": "deal-codename-documents",
    "title": "Company Deck",
    "section": "Deal Workspace",
    "route": "/deal/:codename/documents",
    "authRequired": true,
    "params": [
      "codename"
    ]
  },
  {
    "id": "deal-codename-evidence",
    "title": "Company Evidence",
    "section": "Deal Workspace",
    "route": "/deal/:codename/evidence",
    "authRequired": true,
    "params": [
      "codename"
    ]
  },
  {
    "id": "deal-codename-files",
    "title": "Company Files",
    "section": "Deal Workspace",
    "route": "/deal/:codename/files",
    "authRequired": true,
    "params": [
      "codename"
    ]
  },
  {
    "id": "deal-codename-data-room",
    "title": "Company Files",
    "section": "Deal Workspace",
    "route": "/deal/:codename/data-room",
    "authRequired": true,
    "params": [
      "codename"
    ]
  },
  {
    "id": "deal-codename-investigations",
    "title": "Company Investigations",
    "section": "Deal Workspace",
    "route": "/deal/:codename/investigations",
    "authRequired": true,
    "params": [
      "codename"
    ]
  },
  {
    "id": "deal-codename-overview",
    "title": "Company Overview",
    "section": "Deal Workspace",
    "route": "/deal/:codename/overview",
    "authRequired": true,
    "params": [
      "codename"
    ]
  },
  {
    "id": "deal-codename-systems",
    "title": "Company Systems",
    "section": "Deal Workspace",
    "route": "/deal/:codename/systems",
    "authRequired": true,
    "params": [
      "codename"
    ]
  },
  {
    "id": "deal-codename-access",
    "title": "Data Access Request",
    "section": "Deal Workspace",
    "route": "/deal/:codename/access",
    "authRequired": true,
    "params": [
      "codename"
    ]
  },
  {
    "id": "deal-codename-benchmarks",
    "title": "Desk Benchmarks",
    "section": "Deal Workspace",
    "route": "/deal/:codename/benchmarks",
    "authRequired": true,
    "params": [
      "codename"
    ]
  },
  {
    "id": "deal-codename-monitoring",
    "title": "Desk Company Monitoring",
    "section": "Deal Workspace",
    "route": "/deal/:codename/monitoring",
    "authRequired": true,
    "params": [
      "codename"
    ]
  },
  {
    "id": "deal-codename-score",
    "title": "Desk Score",
    "section": "Deal Workspace",
    "route": "/deal/:codename/score",
    "authRequired": true,
    "params": [
      "codename"
    ]
  },
  {
    "id": "deal-codename-desk",
    "title": "Evidence Desk",
    "section": "Deal Workspace",
    "route": "/deal/:codename/desk",
    "authRequired": true,
    "params": [
      "codename"
    ]
  },
  {
    "id": "deal-new",
    "title": "New Read Entry",
    "section": "Deal Workspace",
    "route": "/deal/new",
    "authRequired": true,
    "params": []
  },
  {
    "id": "marked-up-letter",
    "title": "Marked Up Letter Index",
    "section": "Design Library",
    "route": "/marked-up-letter",
    "authRequired": false,
    "params": []
  },
  {
    "id": "marked-up-letter-slug",
    "title": "Marked Up Letter Route",
    "section": "Design Library",
    "route": "/marked-up-letter/:slug",
    "authRequired": false,
    "params": [
      "slug"
    ]
  },
  {
    "id": "mul-kit",
    "title": "Mul Kit",
    "section": "Design Library",
    "route": "/mul-kit",
    "authRequired": false,
    "params": []
  },
  {
    "id": "founder-followup-token",
    "title": "Founder Follow Up Response",
    "section": "External / Token",
    "route": "/founder-followup/:token",
    "authRequired": false,
    "params": [
      "token"
    ]
  },
  {
    "id": "invite-token",
    "title": "Invite",
    "section": "External / Token",
    "route": "/invite/:token",
    "authRequired": false,
    "params": [
      "token"
    ]
  },
  {
    "id": "share-token",
    "title": "Shared Report",
    "section": "External / Token",
    "route": "/share/:token",
    "authRequired": false,
    "params": [
      "token"
    ]
  },
  {
    "id": "digest",
    "title": "Desk Digest",
    "section": "Investor Desk",
    "route": "/digest",
    "authRequired": true,
    "params": []
  },
  {
    "id": "findings",
    "title": "Desk Findings",
    "section": "Investor Desk",
    "route": "/findings",
    "authRequired": true,
    "params": []
  },
  {
    "id": "inbox",
    "title": "Desk Inbox",
    "section": "Investor Desk",
    "route": "/inbox",
    "authRequired": true,
    "params": []
  },
  {
    "id": "alerts",
    "title": "Desk Inbox",
    "section": "Investor Desk",
    "route": "/alerts",
    "authRequired": true,
    "params": []
  },
  {
    "id": "portco-slug",
    "title": "Portco",
    "section": "Investor Desk",
    "route": "/portco/:slug",
    "authRequired": true,
    "params": [
      "slug"
    ]
  },
  {
    "id": "portco-slug-pulse",
    "title": "Portco Pulse",
    "section": "Investor Desk",
    "route": "/portco/:slug/pulse",
    "authRequired": true,
    "params": [
      "slug"
    ]
  },
  {
    "id": "portfolio",
    "title": "Portfolio",
    "section": "Investor Desk",
    "route": "/portfolio",
    "authRequired": true,
    "params": []
  },
  {
    "id": "portfolio-matrix",
    "title": "Portfolio Matrix",
    "section": "Investor Desk",
    "route": "/portfolio/matrix",
    "authRequired": true,
    "params": []
  },
  {
    "id": "portfolio-queue",
    "title": "Portfolio Queue",
    "section": "Investor Desk",
    "route": "/portfolio/queue",
    "authRequired": true,
    "params": []
  },
  {
    "id": "reads",
    "title": "Reads",
    "section": "Investor Desk",
    "route": "/reads",
    "authRequired": true,
    "params": []
  },
  {
    "id": "onboarding-threshold",
    "title": "Case Open",
    "section": "Onboarding",
    "route": "/onboarding/threshold",
    "authRequired": true,
    "params": []
  },
  {
    "id": "onboarding-context",
    "title": "Onboarding Context",
    "section": "Onboarding",
    "route": "/onboarding/context",
    "authRequired": true,
    "params": []
  },
  {
    "id": "onboarding-welcome",
    "title": "Onboarding Retired Redirect",
    "section": "Onboarding",
    "route": "/onboarding/welcome",
    "authRequired": true,
    "params": []
  },
  {
    "id": "onboarding-mode",
    "title": "Onboarding Retired Redirect",
    "section": "Onboarding",
    "route": "/onboarding/mode",
    "authRequired": true,
    "params": []
  },
  {
    "id": "onboarding-oath",
    "title": "Onboarding Retired Redirect",
    "section": "Onboarding",
    "route": "/onboarding/oath",
    "authRequired": true,
    "params": []
  },
  {
    "id": "onboarding-intent",
    "title": "Onboarding Retired Redirect",
    "section": "Onboarding",
    "route": "/onboarding/intent",
    "authRequired": true,
    "params": []
  },
  {
    "id": "onboarding-how-it-works",
    "title": "Onboarding Retired Redirect",
    "section": "Onboarding",
    "route": "/onboarding/how-it-works",
    "authRequired": true,
    "params": []
  },
  {
    "id": "onboarding-trust",
    "title": "Onboarding Retired Redirect",
    "section": "Onboarding",
    "route": "/onboarding/trust",
    "authRequired": true,
    "params": []
  },
  {
    "id": "ask-library",
    "title": "Ask Zoe Library",
    "section": "Other",
    "route": "/ask/library",
    "authRequired": true,
    "params": []
  },
  {
    "id": "ask-chat",
    "title": "Ask Zoe New Chat",
    "section": "Other",
    "route": "/ask/chat",
    "authRequired": true,
    "params": []
  },
  {
    "id": "ask-projects-projectid",
    "title": "Ask Zoe Project",
    "section": "Other",
    "route": "/ask/projects/:projectId",
    "authRequired": true,
    "params": [
      "projectId"
    ]
  },
  {
    "id": "ask-projects",
    "title": "Ask Zoe Projects",
    "section": "Other",
    "route": "/ask/projects",
    "authRequired": true,
    "params": []
  },
  {
    "id": "ask-chat-threadid",
    "title": "Ask Zoe Thread",
    "section": "Other",
    "route": "/ask/chat/:threadId",
    "authRequired": true,
    "params": [
      "threadId"
    ]
  },
  {
    "id": "compare-companies",
    "title": "Company Comparison",
    "section": "Other",
    "route": "/compare-companies",
    "authRequired": true,
    "params": []
  },
  {
    "id": "connect",
    "title": "Connect Assistant",
    "section": "Other",
    "route": "/connect",
    "authRequired": false,
    "params": []
  },
  {
    "id": "join-token",
    "title": "Join Workspace",
    "section": "Other",
    "route": "/join/:token",
    "authRequired": false,
    "params": [
      "token"
    ]
  },
  {
    "id": "magic-link",
    "title": "Magic Link",
    "section": "Other",
    "route": "/magic-link",
    "authRequired": false,
    "params": []
  },
  {
    "id": "oauth-consent",
    "title": "OAuth Consent",
    "section": "Other",
    "route": "/oauth/consent",
    "authRequired": true,
    "params": []
  },
  {
    "id": "onboarding",
    "title": "Onboarding Retired Redirect",
    "section": "Other",
    "route": "/onboarding",
    "authRequired": true,
    "params": []
  },
  {
    "id": "operator-access",
    "title": "Operator Access",
    "section": "Other",
    "route": "/operator-access",
    "authRequired": false,
    "params": []
  },
  {
    "id": "operator-waitlist",
    "title": "Operator Waitlist",
    "section": "Other",
    "route": "/operator-waitlist",
    "authRequired": false,
    "params": []
  },
  {
    "id": "security-two-factor",
    "title": "Two Factor Setup",
    "section": "Other",
    "route": "/security/two-factor",
    "authRequired": false,
    "params": []
  }
];
